// src/plugins/httpClient.js
import axios from 'axios'
import { getConfigValue } from '@/services/runtimeConfig'
import { getKeycloak } from '@/plugins/keycloak-plugin'

const apiClient = axios.create({
  baseURL: getConfigValue('BFF_URL', '/'),
  timeout: 10000
})

// Request interceptor — inject Keycloak JWT
apiClient.interceptors.request.use(config => {
  const token = getKeycloak()?.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => Promise.reject(error))

// Response interceptor — handle 401 token expiry with automatic refresh
apiClient.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status
    if (status === 401 && !error.config._retried) {
      error.config._retried = true
      try {
        const refreshed = await getKeycloak()?.updateToken(30)
        if (refreshed) {
          error.config.headers.Authorization = `Bearer ${getKeycloak()?.token}`
          return apiClient.request(error.config)
        }
      } catch {
        getKeycloak()?.login()
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
